/**
 * Tatbikat icra kaydı (Records ve Execution Wizard; ADR 0128 Faz 3 Ek) metinleri. Ortağın
 * belgesindeki adlar İngilizcede aynen (General Information, Preparation, Participants, Execution,
 * Evaluation, Close; Completed / Not Completed / N/A; Satisfactory / Needs Improvement; Submit for
 * Master review; Stopped: real emergency). Hata anahtarları sunucunun kodlarıyla eşleşir.
 */

export const drillRecordEn = {
  minutes_one: '{{count}} min',
  minutes_other: '{{count}} min',
  state: {
    in_progress: 'In Progress',
    submitted: 'Awaiting Master',
    approved: 'Approved',
    stopped: 'Stopped: real emergency',
    cancelled: 'Cancelled',
    returned: 'Returned',
    reopened: 'Reopened',
  },
  stages: {
    general: 'General Information',
    preparation: 'Preparation',
    participants: 'Participants',
    execution: 'Execution',
    evaluation: 'Evaluation',
    close: 'Close',
  },
  wizard: {
    error: 'The drill record could not be loaded.',
    loading: 'Loading the drill record…',
    back: 'All records',
    version: 'Template v{{version}}',
    versionPinned: 'Template v{{version}} (Library now v{{library}}; this record is not affected)',
    vesselScenario: 'Vessel scenario',
    returned: 'Returned by the Master',
    reopened: 'Reopened for correction',
    awaitingMaster: 'This drill record is awaiting your review.',
    submittedNote:
      'Submitted for Master review. The record cannot be changed until the Master decides.',
    cancelled: 'Record cancelled',
    stages: 'Drill record stages',
    open_one: '{{count}} open item',
    open_other: '{{count}} open items',
    complete: 'Complete',
    previous: 'Previous',
    next: 'Next',
    save: 'Save Progress',
    saveNext: 'Save & Next',
  },
  actions: {
    conduct: 'Conduct Drill',
    stop: 'Stopped: real emergency',
    decide: 'Review & Decide',
    submit: 'Submit for Master review',
    reopen: 'Reopen for Correction',
    cancel: 'Cancel Record',
  },
  issue: {
    REQUIRED: 'Required',
    DURATION_TOO_LONG: 'Longer than 12 hours; check the times',
    NO_PARTICIPANT: 'At least one participant must be present',
    NOT_PRESENT: 'Only a crew member who was present can be assessed',
  },
  issueField: {
    attendance: 'attendance',
    absenceReason: 'reason for absence',
    result: 'result',
    remarks: 'remarks',
    note: 'observation',
  },
  general: {
    drillType: 'Drill Type',
    category: 'Category',
    date: 'Date',
    startTime: 'Start Time',
    endTime: 'End Time',
    duration: 'Duration',
    location: 'Location',
    locationHint: 'Port, anchorage or position at sea.',
    responsible: 'Responsible Officer',
    responsibleUserId: 'Responsible Officer',
    scenario: 'Scenario',
    scenarioHint: 'From the template (or the vessel scenario); adapt it to this drill.',
  },
  preparation: {
    ra: 'Risk assessment verification',
    raHint: 'Operational risk check for the drill (RA-11 Emergency Drills).',
    noRa: 'No verification on this vessel',
    riskNotes: 'Risk notes',
    briefingDone: 'Safety briefing given',
    briefingNotes: 'Briefing notes',
    equipmentReady: 'Equipment ready',
    equipmentNotes: 'Equipment notes',
    equipmentNotesHint: 'Required when the equipment is not ready.',
    weather: 'Weather',
    constraints: 'Operational constraints',
    constraintsHint: 'Navigation, cargo or port restrictions.',
    equipment: 'Template equipment',
    checklist: 'Preparation checklist',
  },
  participants: {
    summary: '{{present}} of {{total}} present',
    restTitle: 'Rest hours',
    restBody_one:
      '{{count}} present participant does not have the drill time recorded as work in Rest Hours. Felix does not change rest hours; record the drill there (MLC A2.3: drills are held so as to minimise disturbance of rest).',
    restBody_other:
      '{{count}} present participants do not have the drill time recorded as work in Rest Hours. Felix does not change rest hours; record the drill there (MLC A2.3: drills are held so as to minimise disturbance of rest).',
    openRest: 'Open Rest Hours',
    name: 'Name',
    role: 'Role',
    attendance: 'Attendance',
    absenceReason: 'Reason for absence',
    absenceHint: 'Only when absent',
    rest: 'Rest hours',
    remove: 'Remove',
    present: 'Present',
    absent: 'Absent',
    restState: {
      covered: 'Recorded',
      partial: 'Partly recorded',
      missing: 'Not recorded',
    },
    add: 'Add crew member',
    addHint: 'Crew on board on the drill date.',
    allListed: 'Everyone on board is listed',
    addButton: 'Add',
  },
  execution: {
    hint: 'Mark each step as Completed, Not Completed or N/A. The time is ship time; the response time is counted from the start time.',
    result: 'Result of step',
    completed: 'Completed',
    notCompleted: 'Not Completed',
    na: 'N/A',
    time: 'Time',
    elapsed: '+{{time}} from start',
    responsible: 'Responsible',
    remarks: 'Remarks',
    remarksHint: 'Required for a step not completed.',
    evidence: 'Evidence of step {{no}}',
    noEvidence: 'No evidence attached.',
    addEvidence: 'Attach photo or PDF',
  },
  evaluation: {
    hint: 'Rate each criterion as Satisfactory or Needs Improvement; muster and response times are measured values (m:ss).',
    measured: 'Measured time',
    measuredHint: 'm:ss, e.g. 8:30',
    rating: 'Rating',
    satisfactory: 'Satisfactory',
    needsImprovement: 'Needs Improvement',
    note: 'Note',
    debriefing: 'Debriefing',
  },
  close: {
    drill: 'Drill',
    date: 'Date',
    time: 'Time',
    responsible: 'Responsible Officer',
    participants: 'Participants',
    participantsValue: '{{present}} of {{total}} present',
    steps: 'Steps',
    stepsValue: '{{completed}} completed, {{notCompleted}} not completed, {{na}} N/A of {{total}}',
    step: 'Step {{no}}',
    ready: 'The record is complete and can be submitted for Master review.',
    missing_one: '{{count}} item to complete before submitting',
    missing_other: '{{count}} items to complete before submitting',
    reportNote:
      'The approved record is the drill report of the vessel. A paper drill report (ISM form) can still be kept and referenced with “Enter Past Drill” in the Planner.',
    history: 'History',
    noHistory: 'Not submitted yet.',
  },
  event: {
    submitted: 'Submitted for Master review',
    reopened: 'Reopened for correction',
    stopped: 'Stopped: real emergency',
    cancelled: 'Cancelled',
  },
  decisionValue: { approved: 'Approved', returned: 'Returned' },
  stop: {
    title: 'Stopped: real emergency',
    hint: 'Stop the drill because of a real emergency. The record is kept but does not count as a conducted drill. Report the emergency in HSEQ as an accident or near miss and link it here, now or later.',
    reason: 'What happened',
    time: 'Stopped at',
    confirm: 'Stop Drill',
    incident: 'HSEQ report',
    incidentHint: 'Accident or near miss report of this vessel.',
    noIncidents: 'No accident or near miss report',
    stoppedTitle: 'Drill stopped at {{time}}: real emergency',
    linked: 'Linked to {{no}} · {{title}}',
    notLinked: 'No HSEQ report linked yet.',
    link: 'Link Report',
    openHseq: 'Open HSEQ reports',
  },
  incidentType: { accident: 'Accident', near_miss: 'Near Miss' },
  start: {
    title: 'Conduct Drill',
    hint: 'The drill record uses the current template version; later Library changes do not change it.',
    drill: 'Drill',
    planned: 'In the plan',
    unplanned: 'Not in the plan',
    openExists: 'This drill already has a record in progress; it will be opened.',
    date: 'Drill date',
    dateHint: 'Ship date; not in the future.',
    submit: 'Start',
  },
  submit: {
    title: 'Submit for Master review',
    body: '{{no}} of {{date}} will be sent to the Master. It cannot be changed until the Master decides.',
    confirm: 'Submit',
  },
  decision: {
    title: 'Drill record decision',
    comment: 'Comment',
    commentHint: 'Required to return the record.',
    return: 'Return',
    approve: 'Approve',
  },
  reopen: {
    title: 'Reopen for correction',
    hint: 'The approved record is reopened for correction. The previous approval stays in the history and the Last Conducted date is kept.',
    reason: 'Reason',
    confirm: 'Reopen',
  },
  cancel: {
    title: 'Cancel record',
    hint: 'Cancel a record started by mistake. It is kept with the reason and cannot be reopened.',
    reason: 'Reason',
    confirm: 'Cancel Record',
  },
  fields: { now: 'Now (ship time)', yes: 'Yes', no: 'No' },
  list: {
    description:
      'Drill records of the vessel: start a drill from the plan, fill it in stage by stage and submit it for Master review.',
    officeDescription:
      'Drill records of the fleet. Records are kept on board; the office sees them read only.',
    error: 'Drill records could not be loaded.',
    filter: 'Status',
    filters: {
      all: 'All',
      in_progress: 'In Progress',
      submitted: 'Awaiting Master',
      approved: 'Approved',
      stopped: 'Stopped',
      cancelled: 'Cancelled',
    },
    vessel: 'Vessel',
    allVessels: 'All vessels',
    empty: 'No drill records yet.',
    noMatch: 'No record matches the filter.',
  },
  columns: {
    recordNo: 'Record No.',
    vessel: 'Vessel',
    drill: 'Drill',
    date: 'Date',
    responsible: 'Responsible Officer',
    participants: 'Present',
    steps: 'Steps done',
    status: 'Status',
  },
  errors: {
    DRILL_RECORD_OPEN: 'This drill already has a record in progress.',
    DRILL_RECORD_LOCKED: 'The record can no longer be changed in its current state.',
    DRILL_RECORD_INCOMPLETE: 'The record is incomplete; complete the open items first.',
    DRILL_RECORD_FIXED: 'This field is fixed when the record is started.',
    INVALID_DRILL_RECORD: 'Check the entered values.',
    INVALID_INCIDENT: 'Only an accident or near miss report can be linked.',
    NOT_ON_BOARD: 'This person was not on board on the drill date.',
    DUPLICATE_PARTICIPANT: 'This person is already listed.',
    STALE_CONTENT: 'The record has changed. Reload and try again.',
    STALE_ROW_VERSION: 'The record has been changed on another computer. Reload and try again.',
    CONTENT_HASH_MISMATCH: 'The record has changed. Reload and try again.',
    MASTER_ONLY: 'Only the Master (or the acting Master) can decide.',
    DRILL_TEMPLATE_INACTIVE: 'This drill template is no longer active.',
    DRILL_PLAN_NOT_ACTIVE: 'The plan is cancelled.',
    FUTURE_DATE: 'The drill date cannot be in the future.',
    INVALID_TIME: 'Enter the time as HH:MM.',
  },
};

export const drillRecordTr: typeof drillRecordEn = {
  minutes_one: '{{count}} dk',
  minutes_other: '{{count}} dk',
  state: {
    in_progress: 'Sürüyor',
    submitted: 'Kaptan Onayında',
    approved: 'Onaylandı',
    stopped: 'Durduruldu: gerçek acil durum',
    cancelled: 'İptal',
    returned: 'İade edildi',
    reopened: 'Yeniden açıldı',
  },
  stages: {
    general: 'Genel Bilgiler',
    preparation: 'Hazırlık',
    participants: 'Katılımcılar',
    execution: 'Uygulama',
    evaluation: 'Değerlendirme',
    close: 'Kapanış',
  },
  wizard: {
    error: 'Tatbikat kaydı yüklenemedi.',
    loading: 'Tatbikat kaydı yükleniyor…',
    back: 'Tüm kayıtlar',
    version: 'Şablon s{{version}}',
    versionPinned: 'Şablon s{{version}} (kütüphane şimdi s{{library}}; bu kayıt etkilenmez)',
    vesselScenario: 'Gemi senaryosu',
    returned: 'Kaptan iade etti',
    reopened: 'Düzeltme için yeniden açıldı',
    awaitingMaster: 'Bu tatbikat kaydı incelemenizi bekliyor.',
    submittedNote: 'Kaptan onayına gönderildi. Kaptan karar verene kadar kayıt değiştirilemez.',
    cancelled: 'Kayıt iptal edildi',
    stages: 'Tatbikat kaydı aşamaları',
    open_one: '{{count}} eksik',
    open_other: '{{count}} eksik',
    complete: 'Tamam',
    previous: 'Önceki',
    next: 'Sonraki',
    save: 'Ara Kaydet',
    saveNext: 'Kaydet ve İlerle',
  },
  actions: {
    conduct: 'Tatbikatı Başlat',
    stop: 'Durdur: gerçek acil durum',
    decide: 'İncele ve Karar Ver',
    submit: 'Kaptan onayına gönder',
    reopen: 'Düzeltme İçin Aç',
    cancel: 'Kaydı İptal Et',
  },
  issue: {
    REQUIRED: 'Zorunlu',
    DURATION_TOO_LONG: '12 saatten uzun; saatleri kontrol edin',
    NO_PARTICIPANT: 'En az bir katılımcı katılmış olmalı',
    NOT_PRESENT: 'Yalnız katılan kişi değerlendirilir',
  },
  issueField: {
    attendance: 'katılım',
    absenceReason: 'gelmeme nedeni',
    result: 'sonuç',
    remarks: 'açıklama',
    note: 'gözlem',
  },
  general: {
    drillType: 'Tatbikat Türü',
    category: 'Kategori',
    date: 'Tarih',
    startTime: 'Başlangıç Saati',
    endTime: 'Bitiş Saati',
    duration: 'Süre',
    location: 'Yer',
    locationHint: 'Liman, demir yeri ya da denizdeki mevki.',
    responsible: 'Sorumlu Zabit',
    responsibleUserId: 'Sorumlu Zabit',
    scenario: 'Senaryo',
    scenarioHint: 'Şablondan (ya da gemi senaryosundan) gelir; bu tatbikata göre düzenleyin.',
  },
  preparation: {
    ra: 'Risk değerlendirmesi doğrulaması',
    raHint: 'Tatbikatın operasyonel risk kontrolü (RA-11 Acil Durum Tatbikatları).',
    noRa: 'Bu gemide doğrulama yok',
    riskNotes: 'Risk notları',
    briefingDone: 'Güvenlik brifingi verildi',
    briefingNotes: 'Brifing notları',
    equipmentReady: 'Ekipman hazır',
    equipmentNotes: 'Ekipman notları',
    equipmentNotesHint: 'Ekipman hazır değilse zorunlu.',
    weather: 'Hava durumu',
    constraints: 'Operasyon kısıtları',
    constraintsHint: 'Seyir, yük ya da liman kısıtları.',
    equipment: 'Şablondaki ekipman',
    checklist: 'Hazırlık listesi',
  },
  participants: {
    summary: '{{total}} kişiden {{present}} katıldı',
    restTitle: 'Dinlenme saatleri',
    restBody_one:
      'Katılan {{count}} kişinin dinlenme kaydında tatbikat süresi çalışma olarak yok. Felix dinlenme saatlerini değiştirmez; tatbikatı orada kaydedin (MLC A2.3: tatbikatlar dinlenmeyi en az bozacak şekilde yapılır).',
    restBody_other:
      'Katılan {{count}} kişinin dinlenme kaydında tatbikat süresi çalışma olarak yok. Felix dinlenme saatlerini değiştirmez; tatbikatı orada kaydedin (MLC A2.3: tatbikatlar dinlenmeyi en az bozacak şekilde yapılır).',
    openRest: 'Dinlenme Saatlerini Aç',
    name: 'Ad',
    role: 'Rol',
    attendance: 'Katılım',
    absenceReason: 'Gelmeme nedeni',
    absenceHint: 'Yalnız gelmediyse',
    rest: 'Dinlenme saati',
    remove: 'Çıkar',
    present: 'Katıldı',
    absent: 'Katılmadı',
    restState: {
      covered: 'Kayıtlı',
      partial: 'Kısmen kayıtlı',
      missing: 'Kayıtlı değil',
    },
    add: 'Mürettebat ekle',
    addHint: 'Tatbikat günü gemide olanlar.',
    allListed: 'Gemideki herkes listede',
    addButton: 'Ekle',
  },
  execution: {
    hint: 'Her adımı Tamamlandı, Tamamlanmadı ya da Uygulanmaz olarak işaretleyin. Saat gemi saatidir; tepki süresi başlangıç saatinden sayılır.',
    result: 'Adımın sonucu',
    completed: 'Tamamlandı',
    notCompleted: 'Tamamlanmadı',
    na: 'Uygulanmaz',
    time: 'Saat',
    elapsed: 'Başlangıçtan +{{time}}',
    responsible: 'Sorumlu',
    remarks: 'Açıklama',
    remarksHint: 'Tamamlanmayan adımda zorunlu.',
    evidence: '{{no}}. adımın kanıtı',
    noEvidence: 'Kanıt eklenmedi.',
    addEvidence: 'Fotoğraf ya da PDF ekle',
  },
  evaluation: {
    hint: 'Her kriteri Yeterli ya da Geliştirilmeli olarak değerlendirin; toplanma ve tepki süreleri ölçülen değerdir (dk:sn).',
    measured: 'Ölçülen süre',
    measuredHint: 'dk:sn, örn. 8:30',
    rating: 'Değerlendirme',
    satisfactory: 'Yeterli',
    needsImprovement: 'Geliştirilmeli',
    note: 'Not',
    debriefing: 'Değerlendirme toplantısı',
  },
  close: {
    drill: 'Tatbikat',
    date: 'Tarih',
    time: 'Saat',
    responsible: 'Sorumlu Zabit',
    participants: 'Katılımcılar',
    participantsValue: '{{total}} kişiden {{present}} katıldı',
    steps: 'Adımlar',
    stepsValue:
      '{{total}} adımdan {{completed}} tamamlandı, {{notCompleted}} tamamlanmadı, {{na}} uygulanmaz',
    step: '{{no}}. adım',
    ready: 'Kayıt eksiksiz; kaptan onayına gönderilebilir.',
    missing_one: 'Göndermeden önce tamamlanacak {{count}} madde',
    missing_other: 'Göndermeden önce tamamlanacak {{count}} madde',
    reportNote:
      'Onaylı kayıt geminin tatbikat raporudur. Kâğıt tatbikat raporu (ISM formu) tutulmaya devam edebilir ve Planner’da “Geçmiş Tatbikatı Gir” ile kaynak gösterilebilir.',
    history: 'Geçmiş',
    noHistory: 'Henüz gönderilmedi.',
  },
  event: {
    submitted: 'Kaptan onayına gönderildi',
    reopened: 'Düzeltme için yeniden açıldı',
    stopped: 'Durduruldu: gerçek acil durum',
    cancelled: 'İptal edildi',
  },
  decisionValue: { approved: 'Onaylandı', returned: 'İade edildi' },
  stop: {
    title: 'Durdur: gerçek acil durum',
    hint: 'Tatbikatı gerçek bir acil durum yüzünden durdurun. Kayıt saklanır ama yapılmış tatbikat sayılmaz. Acil durumu HSEQ’te kaza ya da ramak kala olarak raporlayın ve şimdi ya da sonra buraya bağlayın.',
    reason: 'Ne oldu',
    time: 'Durdurma saati',
    confirm: 'Tatbikatı Durdur',
    incident: 'HSEQ raporu',
    incidentHint: 'Bu geminin kaza ya da ramak kala raporu.',
    noIncidents: 'Kaza ya da ramak kala raporu yok',
    stoppedTitle: 'Tatbikat {{time}}’de durduruldu: gerçek acil durum',
    linked: '{{no}} · {{title}} raporuna bağlı',
    notLinked: 'Henüz HSEQ raporu bağlanmadı.',
    link: 'Raporu Bağla',
    openHseq: 'HSEQ raporlarını aç',
  },
  incidentType: { accident: 'Kaza', near_miss: 'Ramak Kala' },
  start: {
    title: 'Tatbikatı Başlat',
    hint: 'Tatbikat kaydı şablonun bugünkü sürümünü kullanır; sonraki kütüphane değişiklikleri kaydı değiştirmez.',
    drill: 'Tatbikat',
    planned: 'Planda',
    unplanned: 'Planda değil',
    openExists: 'Bu tatbikatın süren bir kaydı var; o açılacak.',
    date: 'Tatbikat tarihi',
    dateHint: 'Gemi tarihi; gelecekte olamaz.',
    submit: 'Başlat',
  },
  submit: {
    title: 'Kaptan onayına gönder',
    body: '{{date}} tarihli {{no}} kaptana gönderilecek. Kaptan karar verene kadar değiştirilemez.',
    confirm: 'Gönder',
  },
  decision: {
    title: 'Tatbikat kaydı kararı',
    comment: 'Yorum',
    commentHint: 'İade için zorunlu.',
    return: 'İade Et',
    approve: 'Onayla',
  },
  reopen: {
    title: 'Düzeltme için yeniden aç',
    hint: 'Onaylı kayıt düzeltme için yeniden açılır. Önceki onay geçmişte kalır, Son Uygulama tarihi korunur.',
    reason: 'Gerekçe',
    confirm: 'Yeniden Aç',
  },
  cancel: {
    title: 'Kaydı iptal et',
    hint: 'Yanlışlıkla başlatılan kaydı iptal edin. Kayıt gerekçesiyle saklanır ve yeniden açılamaz.',
    reason: 'Gerekçe',
    confirm: 'Kaydı İptal Et',
  },
  fields: { now: 'Şimdi (gemi saati)', yes: 'Evet', no: 'Hayır' },
  list: {
    description:
      'Geminin tatbikat kayıtları: tatbikatı plandan başlatın, aşama aşama doldurun ve kaptan onayına gönderin.',
    officeDescription:
      'Filonun tatbikat kayıtları. Kayıtlar gemide tutulur; ofis salt okunur görür.',
    error: 'Tatbikat kayıtları yüklenemedi.',
    filter: 'Durum',
    filters: {
      all: 'Tümü',
      in_progress: 'Sürüyor',
      submitted: 'Kaptan Onayında',
      approved: 'Onaylı',
      stopped: 'Durduruldu',
      cancelled: 'İptal',
    },
    vessel: 'Gemi',
    allVessels: 'Tüm gemiler',
    empty: 'Henüz tatbikat kaydı yok.',
    noMatch: 'Süzgece uyan kayıt yok.',
  },
  columns: {
    recordNo: 'Kayıt No.',
    vessel: 'Gemi',
    drill: 'Tatbikat',
    date: 'Tarih',
    responsible: 'Sorumlu Zabit',
    participants: 'Katılan',
    steps: 'Yapılan adım',
    status: 'Durum',
  },
  errors: {
    DRILL_RECORD_OPEN: 'Bu tatbikatın süren bir kaydı var.',
    DRILL_RECORD_LOCKED: 'Kayıt bu durumda artık değiştirilemez.',
    DRILL_RECORD_INCOMPLETE: 'Kayıt eksik; önce eksikleri tamamlayın.',
    DRILL_RECORD_FIXED: 'Bu alan kayıt başlatılınca sabitlenir.',
    INVALID_DRILL_RECORD: 'Girilen değerleri kontrol edin.',
    INVALID_INCIDENT: 'Yalnız kaza ya da ramak kala raporu bağlanabilir.',
    NOT_ON_BOARD: 'Bu kişi tatbikat günü gemide değildi.',
    DUPLICATE_PARTICIPANT: 'Bu kişi zaten listede.',
    STALE_CONTENT: 'Kayıt değişti. Yenileyip tekrar deneyin.',
    STALE_ROW_VERSION: 'Kayıt başka bir bilgisayarda değişti. Yenileyip tekrar deneyin.',
    CONTENT_HASH_MISMATCH: 'Kayıt değişti. Yenileyip tekrar deneyin.',
    MASTER_ONLY: 'Yalnız kaptan (ya da kaptan vekili) karar verebilir.',
    DRILL_TEMPLATE_INACTIVE: 'Bu tatbikat şablonu artık etkin değil.',
    DRILL_PLAN_NOT_ACTIVE: 'Plan iptal edilmiş.',
    FUTURE_DATE: 'Tatbikat tarihi gelecekte olamaz.',
    INVALID_TIME: 'Saati SS:DD biçiminde girin.',
  },
};
